import React from 'react';

function About() {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">About Home Lead IQ</h1>
      <p>Home Lead IQ is a smart lead capture and automation platform designed for mortgage professionals. Our AI tools help you capture, qualify, and follow up on leads directly from Facebook conversations and more.</p>
    </div>
  );
}

export default About;